import { RotateCw } from 'lucide-react';
import type { PointerEvent, ReactElement } from 'react';
import { HANDLE_HIT_TOLERANCE_PX, ROTATE_HANDLE_RADIUS_PX } from '@/features/design-editor';

interface RotateHandleProps {
  /** 화면 px 중심. */
  readonly x: number;
  readonly y: number;
  /** 지금 돌리는 중이면 커서를 grabbing 으로 바꾼다. */
  readonly rotating: boolean;
  readonly onPointerDown: (event: PointerEvent<SVGElement>) => void;
}

const ICON_PX = 12;

/**
 * 회전 손잡이 — 파워포인트처럼 흰 동그라미 안에 둥근 화살표 아이콘을 둔다. 누르는 자리는 핸들 히트 허용 거리와 같은 반지름이다.
 */
export const RotateHandle = ({
  x,
  y,
  rotating,
  onPointerDown,
}: RotateHandleProps): ReactElement => (
  <g
    className="pointer-events-auto"
    style={{ cursor: rotating ? 'grabbing' : 'grab' }}
    data-handle="rotate"
    data-testid="rotate-handle"
    aria-label="회전 손잡이"
    onPointerDown={onPointerDown}
  >
    <circle cx={x} cy={y} r={HANDLE_HIT_TOLERANCE_PX} fill="transparent" />
    <circle
      cx={x}
      cy={y}
      r={ROTATE_HANDLE_RADIUS_PX}
      className="fill-background stroke-current"
      strokeWidth={1}
    />
    <RotateCw
      x={x - ICON_PX / 2}
      y={y - ICON_PX / 2}
      width={ICON_PX}
      height={ICON_PX}
      strokeWidth={2.5}
      className="stroke-current"
      aria-hidden
    />
  </g>
);
